import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import FooterContent from "@/shared/ui/footer-content";
import FooterHero from "@/shared/ui/footer-hero";

export default /*#__PURE__*/_defineComponent({
  __name: 'VFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(FooterHero)),
    _createVNode(_unref(FooterContent))
  ]))
}
}

})